import { Response } from '_metronic/helpers'
import { ArquivoDto } from 'app/modules/apps/atendimento/core/_models'

export type TipoFornecedor = 'EQUIPAMENTO' | 'MANUTENCAO' | 'CALIBRACAO' | 'PECAS' | 'SERVICOS'

export const TIPOS_FORNECEDOR: TipoFornecedor[] = [
  'EQUIPAMENTO',
  'MANUTENCAO',
  'CALIBRACAO',
  'PECAS',
  'SERVICOS',
]

export type FornecedorList = {
  id: number
  nome: string
  nomeFantasia?: string | null
  cnpj?: string | null
  tipos: TipoFornecedor[]
  ativo: boolean
  logoCadastrada: boolean
}

export type FornecedorView = FornecedorList & {
  inscricaoEstadual?: string | null
  email?: string | null
  telefone?: string | null
  site?: string | null
  observacoes?: string | null
  logo?: ArquivoDto | null
  dataInclusao?: string
  dataAlteracao?: string
}

export type ContatoList = {
  id: number
  tipoContato: string
  nome: string
  email?: string | null
  telefoneContato?: string | null
  telefoneMensagem?: string | null
  ativo?: boolean | null
}

/** Tipo do contato que o backend grava a partir de `contatoNome`/`contatoTelefone`/`contatoEmail`. */
export const TIPO_CONTATO_FORNECEDOR = 'Atendimento'

export type FornecedorEdicao = FornecedorView & { contato?: ContatoList | null }

/**
 * Corpo de POST/PUT. No PUT do fornecedor, campo ausente ou `null` MANTÉM o valor e só a string
 * vazia limpa — o contrário do PUT de gestão do dispositivo.
 */
export type FornecedorDto = {
  id?: number
  nome: string
  nomeFantasia: string
  cnpj: string
  inscricaoEstadual: string
  email: string
  telefone: string
  site: string
  contatoNome: string
  contatoTelefone: string
  contatoEmail: string
  tipos: TipoFornecedor[]
  observacoes: string
  ativo: boolean
}

export type FornecedoresQueryResponse = Response<FornecedorList[]>
